__turbopack_context__.v({
  "bannerContainer": "policies-module-sass-module__9GEz7W__bannerContainer",
  "casino": "policies-module-sass-module__9GEz7W__casino",
  "content": "policies-module-sass-module__9GEz7W__content",
  "contentTermsAndConditions": "policies-module-sass-module__9GEz7W__contentTermsAndConditions",
  "faqHeadText": "policies-module-sass-module__9GEz7W__faqHeadText",
  "header": "policies-module-sass-module__9GEz7W__header",
  "numeric": "policies-module-sass-module__9GEz7W__numeric",
  "payments": "policies-module-sass-module__9GEz7W__payments",
  "print": "policies-module-sass-module__9GEz7W__print",
  "sportsNav": "policies-module-sass-module__9GEz7W__sportsNav",
  "subHeader": "policies-module-sass-module__9GEz7W__subHeader",
});
